<template>
  <v-layout
    @click="goToNotifications(topFixNotifications[0].notification_id)"
    id="snackbar-news"
    v-if="topFixNotifications.length"
    class="snackbar-news pointer"
    column
  >
    <v-flex class="link-notification pointer">
      {{ `Тема: ${topFixNotifications[0].data.theme}` }}
    </v-flex>
    <v-flex>
      {{ `Дата создания: ${$formatDate(topFixNotifications[0].created_at, 'prettyDateWithoutSeconds')}` }}
    </v-flex>

    <v-textarea
      class="news_message pointer pt-0 mt-2"
      readonly
      rows="15"
      :value="topFixNotifications[0].data.message"
    />
    <v-flex class="check-by-non_fixed pointer" @click.stop="showConfirmDialog = true">
      <v-icon color="#eab8a0">clear</v-icon>
    </v-flex>

    <pl-modal @close="showConfirmDialog = !showConfirmDialog" :visible="showConfirmDialog" max-width="400px">
      <div slot="header">
        <span>Подтвердите действие</span>
      </div>

      <div slot="content">
        <span>Данное уведомление отмечено как важное. Вы уверены, чтобы хотите его убрать ?</span>
      </div>

      <v-layout justify-end slot="footer">
        <v-btn class="pl-btn pl-btn_gray" @click="showConfirmDialog = !showConfirmDialog">Закрыть</v-btn>
        <v-btn class="pl-btn pl-btn_primary" @click="confirmFix()">Скрыть уведомление</v-btn>
      </v-layout>
    </pl-modal>
  </v-layout>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import snack from '@/helpers/snack'

export default {
  name: 'SnackbarNews',
  props: {
    unreadNotification: {
      type: Array,
    },
  },

  data: () => ({
    topFixNotifications: [],
    showConfirmDialog: false,
  }),
  computed: {
    ...mapGetters(['user', 'idUnfixNews', 'idFixNews']),
  },
  async mounted() {
    const res = await this.$axios(`${this.$config.server}/${this.$config.modules.crm.api.news.fixSticky}`, {
      params: {
        sticky: true,
      },
    })

    this.topFixNotifications = res.data.data
  },
  methods: {
    ...mapMutations(['setIdUnfixNews', 'setIdFixNews']),
    confirmFix() {
      this.$axios
        .put(`${this.$config.server}/${this.$config.modules.crm.api.news.sticky}`, {
          id: this.topFixNotifications[0].notification_id,
        })
        .then(res => {
          this.$store.commit('setIdUnfixNews', this.topFixNotifications[0].notification_id)
          this.topFixNotifications.splice(0, 1)
          this.showConfirmDialog = false
        })
    },
    goToNotifications(val) {
      this.$router.push({ path: '/notifications?tab=NewsList', hash: val })
    },
  },
  watch: {
    'user.id'(newVal, oldVal) {
      if (oldVal) window.Echo.leave(`Employer.${oldVal}`)

      if (newVal) {
        window.Echo.private(`Employer.${newVal}`).notification(notification => {
          if (notification.type === this.$config.TYPE_NOTIFICATIONS.NEWS && notification.sticky) {
            this.$axios
              .get(`${this.$config.server}/${this.$config.modules.crm.api.news.fixSticky}`, {
                params: {
                  sticky: true,
                },
              })
              .then(res => {
                const firstNotification = res.data.data[0]

                const data = {
                  created_at: new Date(),
                  data: {
                    author: firstNotification.author.full_name,
                    sticky: firstNotification.sticky,
                    message: firstNotification.data.message,
                    news_id: firstNotification.news_id,
                    theme: firstNotification.data.theme,
                  },
                  id: firstNotification.notification_id,
                }
                this.topFixNotifications.unshift(data)
                let snackbarNews = document.getElementById('snackbar-news')
                snackbarNews.classList.add('progress')
              })
              .catch(e => {
                snack.add('Ошибка загрузки', 'error')
                console.log(e)
              })
          }
        })
      }
    },
    idUnfixNews(val) {
      this.topFixNotifications = _.filter(this.topFixNotifications, notification => {
        return notification.notification_id !== val
      })
    },
    idFixNews(val) {
      this.topFixNotifications.unshift(val)
    },
  },
}
</script>

<style lang="scss">
.snackbar-news {
  display: flex;
  max-height: 200px;
  max-width: 30%;
  min-width: 400px !important;
  position: fixed;
  bottom: 100px;
  right: 10px;
  border: 1px solid #f65102;
  border-radius: 5px;
  padding: 20px;
  background: #feefe8;
  z-index: 10;

  &:after {
    content: '';
    position: absolute;
    top: 140px;
    left: 0;
    height: 40px;
    width: 100%;
    background: linear-gradient(rgba(0, 0, 0, 0), #feefe8);
  }

  .news_message {
    height: auto;
    margin-bottom: 0;
    overflow: hidden;
    position: relative;
    flex: 1;
    display: -webkit-box;
    font-size: 14px;

    textarea {
      cursor: pointer;
      overflow: hidden;
    }
  }

  .check-by-non_fixed {
    position: absolute;
    right: 5px;
    top: 5px;
  }

  .link-notification {
    font-weight: 500;
  }

  .progress {
    animation: go-opacity 2s;
  }

  @keyframes go-opacity {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}
</style>
